module.exports = __webpack_public_path__ + "static/img/GEOFF_MARSH.0f88d70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GEOFF_MARSH.jpg
// module id = 5nE1
// module chunks = 0